module.exports = __webpack_public_path__ + "assets/img/pdf-bg.532d1db7.png";